module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DvMtq0/tc-custom/9781439677025.jpg?1704886028248",
      "alt": "This image is the cover for the book Maryland in the French & Indian War, Military"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maryland in the French & Indian War, Military\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"It is true, Maryland did not . . . contribute its proportion, but it was, in my opinion, the fault of the Government, and not of the people.\" ~Benjamin Franklin During the French and Indian War the American colonies contributed to the imperial war effort like never before, Maryland included. Maryland's involvement in the war saw colonial governor Horatio Sharpe and the elected delegates of the Lower House in near constant struggle over Maryland's role. They battled over the deployment of Maryland's militia, over raising troops, and over wartime funding. Meanwhile, frontier settlements burned and Maryland's soldiers joined the effort to defend Great Britain's claims to lands west of the Appalachians. Britain's colonies in North America expanded substantially as a result. Local historian Tim Ware details the political as well as the military conflicts Maryland faced in this unique war.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Timothy Ware\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tim Ware grew up outside Martinsburg, West Virginia, in a region filled with history spanning from the colonial period to the American Civil War and beyond. His passion for history pushed him to pursue an undergraduate degree in history from Shepherd University and a graduate degree in American history from American Public University. In his first book, Tim dives into Maryland's participation in a war that began as a skirmish on the frontiers of Pennsylvania and grew into a global war for an empire.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0